export const AvatarIcon = (props?: {
  fill?: string;
  className?: string;
}) => (
  <svg
    width="26"
    height="26"
    viewBox="0 0 26 26"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={props?.className}
  >
    <g id="Group">
      <path
        id="Vector"
        d="M13 11.75C16.1012 11.75 18.625 9.22625 18.625 6.125C18.625 3.02375 16.1012 0.5 13 0.5C9.89875 0.5 7.375 3.02375 7.375 6.125C7.375 9.22625 9.89875 11.75 13 11.75ZM13 3C14.7238 3 16.125 4.40125 16.125 6.125C16.125 7.84875 14.7238 9.25 13 9.25C11.2775 9.25 9.875 7.84875 9.875 6.125C9.875 4.40125 11.2775 3 13 3Z"
        fill="white"
      />
      <path
        id="Vector_2"
        d="M25.1917 23.9725C23.8917 18.2475 18.878 14.25 13.0005 14.25C7.12175 14.25 2.10925 18.2487 0.810497 23.9725C0.657997 24.6462 1.07925 25.3163 1.753 25.4688C2.42425 25.6188 3.0955 25.1988 3.248 24.5263C4.28675 19.9488 8.29675 16.75 13.0005 16.75C17.703 16.75 21.7142 19.9488 22.753 24.5275C22.8842 25.1075 23.4005 25.5 23.9705 25.5C24.0617 25.5 24.1542 25.49 24.2492 25.47C24.9217 25.3162 25.3442 24.6462 25.1917 23.9725Z"
        fill="white"
      />
    </g>
  </svg>
);
